import LRU from 'lru-cache'
import { withCache } from '@wix/thunderbolt-commons'
import { FetchFn, MetricsReporter } from '@wix/thunderbolt-becky-types'

export const withBeckyCache = (
	fetch: FetchFn,
	metricsReporter: MetricsReporter,
	options: LRU.Options<string, string> & { name: string } = { max: 300, name: 'svg-fetch' }
): FetchFn => {
	const { name, ...lruOptions } = options
	const cache = new LRU<string, string>(lruOptions)
	return withCache((...args) => metricsReporter.runAsyncAndReport(() => fetch(...args), name), cache)
}
